import React from 'react';
import Search from '../users/search';
import Users from '../users/Users';

export const Home = () => {
  return (
    <>
      <Search />
      <Users />
    </>
  );
};
